import { filter, map, pipe, prop, propEq } from 'ramda';

type ItemWithHidden = {
  hidden?: boolean;
  name: string;
};
export const filterHiddenNames = pipe<[ItemWithHidden[]], ItemWithHidden[], string[]>(
  //
  filter(propEq(true, 'hidden')) as any,
  map(prop('name')),
);
